import React from "react";
import classNames from "classnames";
import { IconProps } from "../type";

export function OkIcon({ className, style, ...props }: IconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={classNames(["h-full w-full", className])}
      style={style}
      viewBox='0 0 26 27'
      fill='none'
      {...props}
    >
      <circle cx='13' cy='13.1992' r='13' fill='#F9FBFE' />
      <path
        d='M19.6668 8.19922L10.5002 17.3659L6.3335 13.1992'
        stroke='#050530'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
